export enum DonationOrganizationType {
  Unknown = 0,
  SoleProprietor = 1,
  Partnership = 2,
  LLC = 3,
  Other = 4
}
